import React from 'react'
import Chip from 'Theme/Chip'

import GameTypeIcon from '../_common/GameTypeIcon'

const GameTypesList = ({ gameTypeNames }) =>
  gameTypeNames.map((gameTypeName) => (
    <Chip
      key={gameTypeName}
      size="small"
      label={gameTypeName}
      variant="outlined"
      sx={(theme) => ({
        padding: theme.spacing(0.5, 1.5),
      })}
      icon={
        <GameTypeIcon
          size={'small'}
          gameType={gameTypeName}
          color="text.tertiary"
          paddingRight="9px"
        />
      }
    />
  ))

export default GameTypesList
